import moment from 'moment/moment'
import { EMPTY_FIELD, FORMAT_DATE_INVALID } from './constants'

export default function dateValidate(date) {
  const valid = moment(date).isValid()

  return !date ? EMPTY_FIELD : !valid ? FORMAT_DATE_INVALID : undefined
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/dateValidate.js